import React from "react";
import { motion } from "framer-motion";

// Reusable fade-up wrapper
export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, num }) => (
  <div className="flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.28em] text-zinc-500">
    {num && <span className="font-display text-black">{num}</span>}
    <span className="h-px w-8 bg-black/30" />
    <span>{children}</span>
  </div>
);
